import BunkeyAPI from "../api/BunkeyAPI";
import {
  ASSET_ROOT_GET_DATA,
  ASSET_ROOT_GET_DATA_SUCCESS,
  ASSET_ROOT_GET_DATA_FAILURE,
  ASSET_ROOT_ACTIVEVIEW,
  ASSET_ROOT_EDIT,
  ASSET_ROOT_EDIT_SUCCESS,
  ASSET_ROOT_EDIT_FAILURE,
  ASSET_ROOT_DELETE,
  ASSET_ROOT_DELETE_SUCCESS,
  ASSET_ROOT_DELETE_FAILURE,
  ASSET_ROOT_EDIT_SELECT,
  ASSET_ROOT_EDIT_UNSET_SELECT,
  ASSET_ROOT_SHARE_SELECT,
  ASSET_ROOT_SHARE_UNSET_SELECT,
  ASSET_ROOT_CHECK_SELECT,
  ASSET_ROOT_UNCHECK_SELECT,
  MULTIPLE_ROOT_OPTIONS_ACTIVATE,
  MULTIPLE_ROOT_OPTIONS_DEACTIVATE,
  MULTIPLE_ROOT_OPTIONS_DONE,
  ASSETS_ROOT_MULTI_DELETE,
  ASSETS_ROOT_MULTI_DELETE_SUCCESS,
  ASSETS_ROOT_MULTI_DELETE_FAILURE,
  ASSETS_ROOT_MULTI_MOVE,
  ASSETS_ROOT_MULTI_MOVE_SUCCESS,
  ASSETS_ROOT_MULTI_MOVE_FAILURE,
  CLEAN_DATA_BACK_ROOT,
  SCROLL_ROOT
} from "../constants/assets-root-types";
import {
  UPDATE_COMMENT_DART,
  LOADING_COMMENT_DART,
  LOADING_COMMENT_DART_ERROR
} from "../constants/comment-types";
import store from "../store";
import { sendNotification, permissionsDefault } from "../utils";
import { createComment } from "./CommentAction";

export const cleanDataBackRoot = () => {
  return dispatch => {
    dispatch({
      type: CLEAN_DATA_BACK_ROOT
    });
  };
};
export const scrollRoot = (isShow, page) => {
  return dispatch => {
    dispatch({
      type: SCROLL_ROOT,
      payload: {
        showScrolling: isShow,
        pageScrolling: page
      }
    });
  };
};
export const getRoot = (
  workclient,
  folderselect,
  isFetching = true,
  data = [],
  page = 1,
  limit = 1000
) => {
  const user = store.getState().authUser.user;
  return dispatch => {
    dispatch({
      type: ASSET_ROOT_GET_DATA,
      payload: {
        isFetching: data.length === 0 ? isFetching : false,
        data,
        isLoadingScroll: data.length !== 0 ? true : false
      }
    });

    // Devolvemos la promesa, igual que getExplore.
    return BunkeyAPI({
      url: `/clients/${workclient}/objects/${folderselect}`,
      method: "GET",
      params: {
        page: page,
        limit: limit
      }
    })
      .then(resp => {
        dispatch({
          type: ASSET_ROOT_GET_DATA_SUCCESS,
          payload: {
            user,
            folderselect,
            data: resp.data.children
              .filter(r => r.type === "folder")
              .map(r => {
                return {
                  _id: r._id,
                  type: "bunker",
                  name: r.name,
                  group: r.group,
                  tagProtocol: r.tagProtocol,
                  longDescription: r.longDescription,
                  objectGroups: r.objectGroup,
                  matrix: permissionsDefault().map(def => {
                    const exists = r.group.find(r =>
                      r.permissions.find(
                        item =>
                          item.action === def.action && item.enabled === true
                      )
                    );
                    return {
                      action: def.action,
                      enabled: exists ? true : false
                    };
                  }),
                  uuid: r.uuid
                };
              }),
            headers: resp.headers
          }
        });
      })
      .catch(err => {
        dispatch({
          type: ASSET_ROOT_GET_DATA_FAILURE,
          payload: err
        });
      });
  };
};

export const setRootActiveView = view => {
  return dispatch => {
    dispatch({
      type: ASSET_ROOT_ACTIVEVIEW,
      payload: {
        activeView: view
      }
    });
  };
};

// export const setExpandRootAsset = (asset) => {
// }

export const deleteRootAsset = (workclient, id, intl, multiple) => {
  return dispatch => {
    dispatch({ type: ASSET_ROOT_DELETE });
    BunkeyAPI({
      url: `/clients/${workclient}/objects/${id}`,
      method: "DELETE"
    })
      .then(resp => {
        dispatch({
          type: ASSET_ROOT_DELETE_SUCCESS,
          payload: {
            workclient,
            id
          }
        });
        // if (multiple) {
        sendNotification(
          "success",
          intl,
          intl.formatMessage({ id: "asset_has_been_deleted" })
        );
        // }
      })
      .catch(err => {
        dispatch({
          type: ASSET_ROOT_DELETE_FAILURE,
          payload: {
            workclient,
            id,
            error: err
          }
        });
        // if (multiple) {
        sendNotification(
          "error",
          intl,
          `${intl.formatMessage({ id: "the_asset" })}${intl.formatMessage({
            id: "could_not_move"
          })}`
        );
        // }
      });
  };
};

export const setEditRootAsset = (workclient, asset, notf = null) => {
  return dispatch => {
    dispatch({ type: ASSET_ROOT_EDIT });
    dispatch({
      type: LOADING_COMMENT_DART,
      payload: {
        loadingStatusAsset: asset.statusAsset ? true : false,
        loadingDescription: asset.description ? true : false,
        loadingItemsMedia: asset.typeMedia || null
      }
    });

    //typeMedia es netamente informativo, no se necesita enviar a la API
    delete asset.typeMedia;

    BunkeyAPI({
      url: `/clients/${workclient}/objects/${asset._id}`,
      method: "PUT",
      data: {
        _id: asset._id,
        name: asset.name || undefined,
        metadata: {
          descriptiveTags: asset.metadata.descriptiveTags || undefined,
          createdDate: asset.metadata.createDate || undefined,
          dueDate: asset.metadata.dueDate || undefined
        },
        description: asset.description || undefined,
        statusAsset: asset.statusAsset || undefined,
        media: asset.media || undefined
      }
    })
      .then(resp => {
        dispatch({
          type: ASSET_ROOT_EDIT_SUCCESS,
          payload: {
            data: asset,
            headers: resp.headers
          }
        });
        let payloadDart = {};
        if (asset.description) payloadDart.description = asset.description;
        if (asset.statusAsset) payloadDart.statusAsset = asset.statusAsset;
        if (asset.media) payloadDart.media = asset.media;
        dispatch({
          type: UPDATE_COMMENT_DART,
          payload: {
            ...payloadDart,
            loadingStatusAsset: false,
            loadingDescription: false,
            loadingItemsMedia: null
          }
        });

        //Creamos el comentario informativo
        if (
          notf &&
          (asset.statusAsset || asset.description || asset.media) &&
          notf.intl &&
          notf.user
        ) {
          const setText = ({ intl, ...obj }) => {
            let text = null;

            if (asset.statusAsset) {
              const { statusNew, statusOld } = obj;
              text = intl.formatMessage(
                {
                  id: statusOld
                    ? "change_status_asset"
                    : "change_status_asset_firts"
                },
                {
                  status_old: statusOld ? statusOld.title : "",
                  status_new: statusNew.title
                }
              );
            } else if (asset.media) {
              const { titleMedia, nameMedia, enabledMedia } = obj;
              text = intl.formatMessage(
                {
                  id: enabledMedia
                    ? "change_status_stamp_off"
                    : "change_status_stamp"
                },
                { name_stamp: nameMedia, title_stamp_client: titleMedia }
              );
            } else {
              text = intl.formatMessage({
                id: "change_status_description"
              });
            }

            return text;
          };

          if (
            (asset.description && !notf.isOldDescription) ||
            asset.statusAsset ||
            asset.media
          )
            dispatch(
              createComment(
                asset._id,
                -1,
                null,
                setText(notf),
                notf.user._id,
                null,
                workclient,
                [],
                2 //type
              )
            );
        }
      })
      .catch(err => {
        dispatch({
          type: ASSET_ROOT_EDIT_FAILURE,
          payload: err
        });
        dispatch({
          type: LOADING_COMMENT_DART_ERROR
        });
      });
  };
};

export const setSelectEditRootAsset = (asset, editAssetTab) => {
  return dispatch => {
    dispatch({
      type: ASSET_ROOT_EDIT_SELECT,
      payload: {
        data: asset,
        editAssetTab
      }
    });
  };
};

export const unsetSelectEditRootAsset = () => {
  return dispatch => {
    dispatch({
      type: ASSET_ROOT_EDIT_UNSET_SELECT
    });
  };
};

export const setSelectShareRootAsset = asset => {
  return dispatch => {
    dispatch({
      type: ASSET_ROOT_SHARE_SELECT,
      payload: {
        data: asset
      }
    });
  };
};

export const unsetSelectShareRootAsset = () => {
  return dispatch => {
    dispatch({
      type: ASSET_ROOT_SHARE_UNSET_SELECT
    });
  };
};

export const setCheckRootAsset = asset => {
  return dispatch => {
    dispatch({
      type: ASSET_ROOT_CHECK_SELECT,
      payload: asset
    });
  };
};

export const unsetCheckRootAsset = asset => {
  return dispatch => {
    dispatch({
      type: ASSET_ROOT_UNCHECK_SELECT,
      payload: asset
    });
  };
};

export const activateRootOptions = () => {
  return dispatch => {
    dispatch({
      type: MULTIPLE_ROOT_OPTIONS_ACTIVATE
    });
  };
};

export const deactivateRootOptions = () => {
  return dispatch => {
    dispatch({
      type: MULTIPLE_ROOT_OPTIONS_DEACTIVATE
    });
  };
};

export const isDoneMultipeRootOptions = () => {
  return dispatch => {
    dispatch({
      type: MULTIPLE_ROOT_OPTIONS_DONE
    });
  };
};
export const multiDeleteRootAsset = (workclient, intl, items) => {
  return dispatch => {
    dispatch({ type: ASSETS_ROOT_MULTI_DELETE });
    BunkeyAPI({
      url: `/clients/${workclient}/objects-deletemany`,
      method: "PUT",
      data: {
        data: items
      }
    })
      .then(resp => {
        dispatch({
          type: ASSETS_ROOT_MULTI_DELETE_SUCCESS,
          payload: {
            workclient,
            ids: items
          }
        });
        sendNotification(
          "success",
          intl,
          intl.formatMessage({ id: "assets_has_been_deleted" })
        );
      })
      .catch(err => {
        dispatch({
          type: ASSETS_ROOT_MULTI_DELETE_FAILURE,
          payload: {
            workclient,
            ids: items,
            error: err
          }
        });
        // if (multiple) {
        sendNotification(
          "error",
          intl,
          `${intl.formatMessage({ id: "assets_has_not_been_deleted" })}`
        );
        // }
      });
  };
};
export const moveMultiselectRootAsset = (workclient, ids, folder, intl) => {
  return dispatch => {
    dispatch({ type: ASSETS_ROOT_MULTI_MOVE });
    BunkeyAPI({
      url: `/clients/${workclient}/objects-movemany/${folder}`,
      method: "PUT",
      data: {
        data: ids
      }
    })
      .then(resp => {
        dispatch({
          type: ASSETS_ROOT_MULTI_MOVE_SUCCESS,
          payload: {
            ids: ids,
            headers: resp.headers
          }
        });
        // if (multiple) {
        sendNotification(
          "success",
          intl,
          intl.formatMessage({ id: "assets_have_been_moved" })
        );
        // }
      })
      .catch(err => {
        dispatch({
          type: ASSETS_ROOT_MULTI_MOVE_FAILURE,
          payload: err
        });
        sendNotification(
          "error",
          intl,
          `${intl.formatMessage({ id: "assets_could_not_moved" })}`
        );
      });
  };
};
